<template>
  <div class="adminuser">
    <a-spin :spinning="spinning">
    <!-- ----------------- -->
    <div class="adminuser-title">
      用户管理
    </div>
    <!-- 搜索 -->
    <div class="serach-warp">
      <div class="margin-right-15" style="display: inline-block;vertical-align: top;">
        <search @onSearch="onSearch" placeholder="请输入账号或呢称搜索" />
      </div>
      <div style="display: inline-block;vertical-align: top;">
        <a-button v-if="hasPerm('/admin-user/add')" class="createrBtn" @click="showCreateClick">创建用户</a-button>
      </div>
    </div>
    <!-- 表格 -->
    <adminuser-table ref="adminuserTable" />
    <!-- 创建用户 -->
    <a-modal v-model="visible"
            :mask="true"
            :centered="true"
            :footer="null"
            :maskClosable="true"
    >
      <div class="createTitle">创建用户</div>
      <a-form-model ref="createAdminuser" v-bind="layout" :model="adminuserInfo" :rules="adminuserInfoRules">
        <a-form-model-item has-feedback label="用户账号" prop="name">
          <a-input v-model="adminuserInfo.name" type="text" :maxLength="150"  autocomplete="off"/>
        </a-form-model-item>

        <a-form-model-item has-feedback label="用户昵称" prop="nickname">
          <a-input v-model="adminuserInfo.nickname" type="text" :maxLength="150"  autocomplete="off"/>
        </a-form-model-item>

        <a-form-model-item has-feedback label="手机号" prop="tel">
          <a-input v-model="adminuserInfo.tel" type="text" :maxLength="11"  autocomplete="off"/>
        </a-form-model-item>

        <a-form-model-item has-feedback label="用户密码" prop="password">
          <a-input-password v-model="adminuserInfo.password" placeholder="请输入密码" type="password" :maxLength="150" autocomplete="new-password">
            <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
          </a-input-password>
        </a-form-model-item>

        <a-form-model-item has-feedback label="SSO-UID" prop="uid">
          <a-input v-model="adminuserInfo.uid" type="text" :maxLength="150"  autocomplete="off"/>
        </a-form-model-item>

        <a-form-model-item has-feedback label="对应单位" prop="company">
          <a-input v-model="adminuserInfo.company" type="text" :maxLength="200"  autocomplete="off"/>
        </a-form-model-item>

<!--        <a-form-model-item has-feedback label="分配角色" prop="remark">-->
<!--          <a-input v-model="adminuserInfo.remark" type="text" autocomplete="off" :maxLength="11" />-->
<!--        </a-form-model-item>-->

      </a-form-model>

      <div class="btn-wrap">
        <a-button class="cancel margin-right-15" @click="cancel">取消</a-button>
        <a-button class="create" @click="submitForm('createAdminuser')">创建</a-button>
      </div>

    </a-modal>
    </a-spin>
  </div>
</template>

<script>
import { CreateAdminuser } from "api/adminuser"

import search from "@/components/content/search/Search";
import AdminuserTable from './childComps/AdminuserTable';
import {hasPermission} from 'utils/hasPermission'

export default {
  name: 'Adminuser',
  components: {
    search,
    AdminuserTable
  },
  data() {
    let checkPending;
    let validateNickname = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('用户账号不能为空'));
      } else {
        callback();
      }
    };
    let validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('账号密码不能为空'));
      } else if(value.length < 6){
        callback(new Error('密码长度需6位及以上'));
      } else {
        callback();
      }
    };
    return {
      spinning: false,
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
      },
      visible: false,

      adminuserInfo: {
        name: "",
        password: "",
        nickname: "",
        tel: "",
        company: "",
      },

      adminuserInfoRules: {
        name: [{validator: validateNickname, trigger: 'change'}],
        password: [{validator: validatePassword, trigger: 'change'}],
      }
    }
  },
  methods: {
    hasPerm(perm){
      return hasPermission(perm);
    },
    /**
    * 逻辑区
    */
    // 加载动画
    loading() {
      this.spinning = !this.spinning
    },
    // 搜索
    onSearch(value) {
      this.$refs.adminuserTable.adminuserName = value;
      this.$refs.adminuserTable.pageIndex = 0;
      this.$refs.adminuserTable.pagination.current = 1;
      this.$refs.adminuserTable.getAdminuserListData(0, 10, value)
    },
    // 显示创建用户
    showCreateClick() {
      this.adminuserInfo = {
        name: "",
        password: "",
        nickname: "",
        tel: "",
        company: "",
      }
      this.visible = !this.visible;
    },
    // 取消创建
    cancel() {
      console.log("取消创建");
      this.visible = !this.visible;
      this.adminuserInfo = {
        name: "",
        password: "",
        nickname: "",
        tel: "",
        company: "",
      }
    },
    // 创建用户
    submitForm(formName) {
      const vm = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          vm.create()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /**
    * 接口区
    */
    create() {
      const vm = this;
      this.spinning = true
      CreateAdminuser(this.adminuserInfo.name, this.adminuserInfo.nickname, this.adminuserInfo.password, this.adminuserInfo.uid, this.adminuserInfo.company, this.adminuserInfo.tel)
        .then(res => {
          console.log(res);
          vm.spinning = false
          if (res.code !== 0) {
            vm.$message.error(res.message || res.msg || '创建用户失败');
          } else {
            vm.$message.success('创建用户成功！');
            vm.visible = false;
            vm.onSearch(this.$refs.adminuserTable.adminuserName);
          }
        })
        .catch(err => {
          vm.spinning = false
          console.log(err);
        })
    }
  }
}
</script>

<style lang='scss' scoped>
  .adminuser {
    .adminuser-title {
      font-size: 30px;
      font-weight: 500;
      color: #131212;
    }
    .serach-warp {
      margin: 15px 0;
      .createrBtn {
        color: #fff;
        background-color:rgba($color: #E84D11, $alpha: .6)
      }
    }
  }

  .createTitle {
    line-height: 45px;
    font-size: 28px;
    font-weight: 500;
    text-align: center;
    color: #131212;
    margin-bottom: 30px;
  }
  .btn-wrap {
    text-align: center;
    margin-top: 10px;
    .create {
      color: #fff;
      background-color: #E84D11;
    }
  }
</style>
